import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aa02ac28"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "personal-center"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = {
  class: "info"
};
const _hoisted_4 = {
  class: "m-t-20"
};
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = {
  class: "introduction"
};
const _hoisted_7 = {
  class: "font-14"
};
const _hoisted_8 = {
  class: "flex justify-center m-t-100"
};
const _hoisted_9 = {
  class: "right"
};
const _hoisted_10 = {
  class: "form flex justify-center column"
};
import { useStore } from "@/store";
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import loginApi from "@/api/login";
import api from "@/api/config/info";
import storage from "@/utils/storage";
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const {
      t
    } = useI18n();
    const store = useStore();
    const params = reactive({
      name: store?.info.name,
      // 昵称
      avatar: store?.info.avatar,
      // 头像
      introduction: store?.info.introduction // 介绍
    });
    const infoRules = {
      name: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("users.table.name")
        }),
        trigger: "blur"
      }]
    };
    const passwordForm = reactive({
      oldPassword: "",
      // 旧密码
      newPassword: "",
      // 新密码
      confirmPassword: "" // 确认密码
    });
    const passwordFormRef = ref(null);
    const passwordRules = {
      oldPassword: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("info.oldPassword")
        }),
        trigger: "blur"
      }],
      newPassword: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("info.newPassword")
        }),
        trigger: "blur"
      }, {
        min: 6,
        message: t("common.minLength", {
          val: 6
        }),
        trigger: "blur"
      }],
      confirmPassword: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("info.newPassword")
        }),
        trigger: "blur"
      }, {
        validator: (rule, value, callback) => {
          if (value !== passwordForm.newPassword) {
            // 确保 confirmPassword 与 newPassword 一致
            callback(new Error(t("info.passwordsNotMatch")));
          } else {
            callback();
          }
        },
        trigger: "blur"
      }]
    };
    const uploadFile = ref(null);
    const loading = ref(false);
    const infoFormRef = ref(false);
    const validImageTypes = ["image/jpeg", "image/png", "image/gif", "image/bmp", "image/webp"];
    const handleClick = () => {
      uploadFile.value.click();
    };
    const handleChange = async event => {
      const file = event.target.files[0];
      if (!file) return;
      if (!validImageTypes.includes(file.type)) {
        ElMessage.error(t("common.changeUploadError"));
      } else {
        const formData = new FormData();
        formData.append("file", file);
        loading.value = true;
        try {
          const {
            data
          } = await loginApi.uploadFile(formData);
          if (data.code !== 0) return;
          params.avatar = data.data.path;
          await api.editInfo(params);
          await store.getInfo();
        } finally {
          loading.value = false;
        }
      }
      event.target.value = "";
    };
    // 更新信息
    const handleUpdate = () => {
      infoFormRef.value.validate(async valid => {
        if (!valid) return;
        loading.value = true;
        try {
          const {
            data
          } = await api.editInfo(params);
          if (data.code !== 0) return;
          store.getInfo();
          ElMessage.success(t("action.success"));
        } finally {
          loading.value = false;
        }
      });
    };
    // 修改密码
    const handleChangePassword = () => {
      passwordFormRef.value.validate(async valid => {
        if (!valid) return;
        loading.value = true;
        try {
          const {
            data
          } = await api.changePassword(passwordForm);
          if (data.code !== 0) return;
          ElMessage.success(t("action.success"));
          setTimeout(() => {
            storage.remove("token");
            router.replace("/login");
          }, 1000);
        } finally {
          loading.value = false;
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_divider = _resolveComponent("el-divider");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_card, null, {
        default: _withCtx(() => [_createElementVNode("h4", null, _toDisplayString(_ctx.$t("info.info")), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_avatar, {
          size: 150,
          src: params.avatar,
          onClick: handleClick
        }, null, 8, ["src"]), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(store).info.username), 1), _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(store).info.name), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("info.signature")), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(store).info.introduction), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "danger",
          plain: "",
          size: "large",
          onClick: _unref(store).getOut
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("info.logOut")), 1)]),
          _: 1
        }, 8, ["onClick"])])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_card, null, {
        default: _withCtx(() => [_createElementVNode("h4", null, _toDisplayString(_ctx.$t("info.dataSetting")), 1), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_form, {
          model: params,
          ref_key: "infoFormRef",
          ref: infoFormRef,
          size: "large",
          rules: infoRules,
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('users.table.name'),
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.name = $event),
              clearable: "",
              placeholder: _ctx.$t('common.pleaseEnter', {
                val: _ctx.$t('users.table.name')
              })
            }, null, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('info.account')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              disabled: "",
              clearable: "",
              value: _unref(store).info.username
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('info.signature')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.introduction,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.introduction = $event),
              placeholder: _ctx.$t('common.pleaseEnter', {
                val: _ctx.$t('info.signature')
              }),
              rows: 4,
              type: "textarea",
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: handleUpdate
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.update")), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createVNode(_component_el_divider, {
          style: {
            "margin-bottom": "32px"
          }
        }), _createVNode(_component_el_form, {
          model: passwordForm,
          rules: passwordRules,
          "label-position": "top",
          ref_key: "passwordFormRef",
          ref: passwordFormRef,
          size: "large"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('info.oldPassword'),
            prop: "oldPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: passwordForm.oldPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => passwordForm.oldPassword = $event),
              type: "password",
              "show-password": "",
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('info.newPassword'),
            prop: "newPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: passwordForm.newPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => passwordForm.newPassword = $event),
              type: "password",
              "show-password": "",
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('info.confirmPassword'),
            prop: "confirmPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: passwordForm.confirmPassword,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => passwordForm.confirmPassword = $event),
              type: "password",
              "show-password": "",
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: handleChangePassword
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.changePassword")), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      })]), _createElementVNode("input", {
        type: "file",
        hidden: "",
        ref_key: "uploadFile",
        ref: uploadFile,
        onChange: handleChange
      }, null, 544)])), [[_directive_loading, loading.value]]);
    };
  }
};